import SmartLink from "@/components/marketing/smart-link";

function SolutionDuo({ items }) {
  return (
    <div className="public-solution-duo">
      {items.map((item) => {
        const isEnterprise = item.key === "enterprise";

        return (
          <article
            key={item.key || item.title}
            className={`public-solution-panel ${isEnterprise ? "is-dark" : "is-light"}`}
          >
            <div className="public-solution-panel__top">
              <h3 className="public-solution-panel__title">{item.title}</h3>
              <p className="public-solution-panel__copy">{item.copy}</p>
            </div>

            <div className="public-solution-panel__bottom">
              {item.fit?.length ? (
                <ul className={`public-list${isEnterprise ? " public-list--light" : ""}`}>
                  {item.fit.map((listItem) => (
                    <li key={listItem}>{listItem}</li>
                  ))}
                </ul>
              ) : null}

              <SmartLink href={item.href} className={`btn mt-4 ${isEnterprise ? "btn-light" : "btn-primary"}`}>
                {item.actionLabel || "Læs mere"}
              </SmartLink>
            </div>
          </article>
        );
      })}
    </div>
  );
}

export default SolutionDuo;
